import { formatVal } from '../../../../../helpers/value'
import { ROW_FORMAT_TIME, ROW_FORMAT_VND_ID } from '../../../constants'

export const isOdd = (index) => index % 2 !== 0

export const formatDataByUnit = (
  rowId,
  colId,
  value,
  formatCurrency,
  locale,
) => {
  return ROW_FORMAT_VND_ID.includes(rowId)
    ? formatCurrency({
        value,
        year: parseInt(colId),
        exchangeRateType: 'lastDayRate',
      })
    : formatVal(value, locale)
}

export const isPercentFormat = (val, rowId) =>
  typeof val === 'number' &&
  !ROW_FORMAT_VND_ID.includes(rowId) &&
  !ROW_FORMAT_TIME.includes(rowId) &&
  !Number.isNaN(val)
